import { render, staticRenderFns } from "./AdminUpdatePassword.vue?vue&type=template&id=2bfb6c8c&"
import script from "./AdminUpdatePassword.vue?vue&type=script&lang=ts&"
export * from "./AdminUpdatePassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports